// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3Wwr1","label":"Section_label__35-2M","contentWrap":"Section_contentWrap__1kiOr","footer":"Section_footer__2k6fX","footerInner":"Section_footerInner__1dQY3"};